import ShareTrapIndividualPopover from './ShareTrapIndividualPopover'
import enhance from './ShareTrapIndividualPopover.enhancer'

export default enhance(ShareTrapIndividualPopover)

export const userColumns = [
  {
    width: 60, field: 'displayPic', label: 'displayPic', format: 'displayPic'
  },
  {
    width: 500, field: 'nameEmail', label: 'nameEmail', format: 'nameEmail'
  },
  {
    width: '100%', 
    field: 'select', 
    selectable: true, 
    hideHeader: true,
    align: 'flex-end',
    format: 'expandBox',
    selectableLabel: 'Remove user'
  }
]
  



// WEBPACK FOOTER //
// ./src/components/organisms/ShareTrapIndividualPopover/index.js